import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { LookInside } from './components/LookInside';
import { Volumes } from './components/Volumes';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-stone-50 font-sans text-stone-900 antialiased" data-id="element-0" data-mp="23vuokdaowwv5">
      <MetaPixel data-id="element-1" data-mp="3ijxpqrsp22kf" />
      <UtmifyScript data-id="element-2" data-mp="3ikh8ubu2yx01" />
      <CountdownBar data-id="element-3" data-mp="3iiwf2oflbi38" />
      <main data-id="element-4" data-mp="3ijfunyhrpue3">
        <Hero data-id="element-5" data-mp="3ihv2gfixenje" />
        <StatsBar data-id="element-6" data-mp="3ii4ppvcl6gle" />
        <Difference data-id="element-7" data-mp="3ml14tc2x3ukl" />
        <Recognize data-id="element-8" data-mp="3mkhm3t5g125i" />
        <WhatsInside data-id="element-9" data-mp="3mjzu58ptda3e" />
        <LookInside data-id="element-10" data-mp="3mjgclt42snpw" />
        <Volumes data-id="element-11" data-mp="3rcj6y3gog175" />
        <InstantAccess data-id="element-12" data-mp="3rbzmaezn6ypf" />
        <Bonuses data-id="element-13" data-mp="3rdkl4gszp3t3" />
        <Offer data-id="element-14" data-mp="3rd189ei755lx" />
        <Guarantee data-id="element-15" data-mp="3relw6la09qat" />
        <Testimonials data-id="element-16" data-mp="5opiv1o0k3w" />
        <Faq data-id="element-17" data-mp="4wupmfw6qeo" />
      </main>
      <Footer data-id="element-18" data-mp="56ntiw8hdol" />
    </div>;
}